<template>
  <div class="event-lists gift d-flex flex-wrap justify-content-between">
    <div
      class="modal fade form-wrapper"
      id="share-wishlist-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="formModalLabel"
      aria-hidden="true"
      v-if="showModal"
      @close="closeShareModal"
      data-backdrop="static"
      data-keyboard="false"
      ref="modal"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content form-content">
          <div class="modal-body">
            <img
              class="close"
              src="assets/images/close.svg"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeShareModal"
            />
            <div class="payment-form">
              <form @submit="shareWishlist" id="shareWishlist" class="shareWishlistForm">
                <div
                  class="alert alert-danger alert-dismissible"
                  role="alert"
                  v-if="showAlertMessage"
                >
                  {{apiErrorMessage}}
                  <img
                    class="close"
                    src="assets/images/close.svg"
                    data-dismiss="alert"
                    aria-label="close"
                    @click="showAlertMessage=!showAlertMessage"
                  />
                </div>

                <div
                  class="alert alert-success alert-dismissible"
                  role="alert"
                  v-if="showSuccessAlertMessage"
                >
                  {{apiSuccessMessage}}
                  <img
                    class="close"
                    src="assets/images/close.svg"
                    data-dismiss="alert"
                    aria-label="close"
                    @click="showSuccessAlertMessage=!showSuccessAlertMessage"
                  />
                </div>

                <div class="form-group">
                  <label for="email">Share by email</label>
                  <div class="event-count">
                    <input
                      class="form-control"
                      id="email"
                      name="email"
                      data-vv-as="email"
                      ref="emailArray"
                      v-bind:class="{ 'is-invalid': errors.has('email')}"
                      placeholder="Email"
                      v-model="emailArray"
                      data-vv-validate-on="'none'"
                      v-validate="'required|emailFormat'"
                    />

                    <span class="invalid-feedback">{{ errors.first('email') }}</span>
                  </div>
                </div>
                <button type="submit" class="btn btn-primary">Share</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SHARE_WISHLIST } from "../store/wishlist/action.type";
export default {
  data() {
    return {
      emailArray: [],
      apiSuccessMessage: "",
      apiErrorMessage: "",
      showAlertMessage: false,
      showSuccessAlertMessage: false
    };
  },
  props: {
    show: Boolean
  },
  created() {
    this.$validator.extend("emailFormat", {
      getMessage: () =>
        "Please provide valid email address.",
      validate: value =>
      // console.log("Value", value)
     {  var emails = value.split(',')


    var valid = true;
    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    for (var i = 0; i < emails.length; i++) {
        if( emails[i] === "" || !regex.test(emails[i].replace(/\s/g, ""))){
            valid = false;
        }
    }
    return valid;
    }
        // value.match(
        //   /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z])[A-Za-z\d@$!%*#?&]{8,}$/
        // ) !== null
    });
  },
  computed: {
    showModal() {
      return this.show === true
        ? $("#share-wishlist-modal").modal("show")
        : $("#share-wishlist-modal").modal("hide");
      // : setTimeout(() => {
      //   $("#share-wishlist-modal").modal("hide");
      // }, 9000).then(() => {
      //   this.showSuccessAlertMessage = false;
      // });
    },

    ...mapGetters(["getShareWishlistId"])
  },

  methods: {
    closeShareModal() {
      this.emailArray = "";
      this.$validator.reset();
      this.$emit("closeShareModal"); //call custom event in parent
    },

    splitArray(emailArray) {
      let email = [];
      let k = emailArray.split(",");
      for (let i = 0; i < k.length; i++) {
        email = k;
      }
      return email;
    },

    shareWishlist(e) {
      e.preventDefault();
      if (this.emailArray.length != 0 || this.emailArray) {
        //check if emailArray has any data
        let body = {
          wishlistId: this.getShareWishlistId,
          email: this.splitArray(this.emailArray)
        };
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.$store
              .dispatch(SHARE_WISHLIST, body)
              .then(response => {
                if (response.status != 200) {
                  this.apiErrorMessage = response.data.message;
                  this.showAlertMessage = true;
                } else {
                  this.apiSuccessMessage = response.data.message;
                  this.showSuccessAlertMessage = true;
                  setTimeout(() => {
                    this.closeShareModal();
                  }, 1000);
                }
              })
              .catch(error => {
                this.apiErrorMessage = error.response.data.message;
                this.showAlertMessage = true;
              });
          }
        });
      }
    }
  },
  watch: {
    showAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showAlertMessage = false;
        }, 2000);
      }
    },
    showSuccessAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showSuccessAlertMessage = false;
        }, 2000);
      }
    }
  }
};
</script>

<style>
/* .shareWishlistForm {
  margin-top: 60px;
} */
.form-group label {
  color: #6d589b;
}
.close {
  position: absolute;
  right: 25px;
  top: 25px;
  cursor: pointer;
}
</style>